/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { CleansingStatisticsPageEntrypointProps } from './CleansingStatisticsPage.entrypoint.types.tsx';

type CleansingStatisticsEntryPointComponent = EntryPointComponent<
	{},
	{},
	CleansingStatisticsPageEntrypointProps,
	{}
>;

export const cleansingStatisticsEntryPoint: EntryPoint<CleansingStatisticsEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<CleansingStatisticsEntryPointComponent>(
			/* webpackChunkName: "async-cleansing-statistics-page" */ './CleansingStatisticsPage.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
